import React, { useState } from 'react';

import { Modal } from 'antd';

import UserForm from '../../../components/users/form';
import { registerUser } from '../../../services/users';

export default function EditUser({ visible, setVisible, onConfirm }) {
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const onFinish = async (values) => {
    try {
      setLoading(true);
      await registerUser(values);
      setVisible(false);
      onConfirm();
    } catch (err) {
      console.log(err.error);
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal
      title="Adicionar usuário"
      centered
      footer={null}
      visible={visible}
      onCancel={() => setVisible(false)}
    >
      <UserForm
        onFinish={onFinish}
        error={error}
        setError={setError}
        initialValues={{ type: 'MARCADOR' }}
        loading={loading}
      />
    </Modal>
  );
}
